import { Provider } from '@angular/core'
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDateFormats,
} from '@angular/material/core'
import { MomentDateAdapter } from '@angular/material-moment-adapter'

import { AuthService } from '../services/auth.service'

const dateFormatFactory = (authService: AuthService): MatDateFormats => {
  return {
    parse: {
      dateInput: authService.user?.settings?.dateFormat || 'MM/DD/YYYY',
    },
    display: {
      dateInput: authService.user?.settings?.dateFormat || 'MM/DD/YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    },
  }
}

export const momentAdapterProviders: Provider[] = [
  {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE],
  },
  {
    provide: MAT_DATE_FORMATS,
    useFactory: dateFormatFactory,
    deps: [AuthService],
  },
]
